// extracted by mini-css-extract-plugin
export default {"Box":"archive-header-wrapper-module__Box--tp2ng","Box_1":"archive-header-wrapper-module__Box_1--NZPNQ"};